// extracted by mini-css-extract-plugin
export default {"banner":"ErrorBanner_banner__dKJFU","icon":"ErrorBanner_icon__pi+cI"};